var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5373 16.2625C11.812 16.5373 12.2571 16.5371 12.5316 16.2625L15.5441 13.25C15.8187 12.9755 15.8187 12.5302 15.5441 12.2557C15.2696 11.9811 14.8244 11.9811 14.5498 12.2557L12.7376 14.0679V8.9873C12.7376 8.59894 12.4227 8.28418 12.0345 8.28418C11.6461 8.28418 11.3313 8.59894 11.3313 8.9873V14.0679L9.51915 12.2557C9.24449 11.9811 8.79936 11.9811 8.5247 12.2557C8.25023 12.5302 8.25023 12.9755 8.5247 13.25L11.5373 16.2625Z",
    fill: "#0E4C54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0468 18.0752H9.02173C8.63354 18.0752 8.3186 18.39 8.3186 18.7783C8.3186 19.1665 8.63354 19.4814 9.02173 19.4814H15.0468C15.435 19.4814 15.7499 19.1665 15.7499 18.7783C15.7499 18.39 15.4352 18.0752 15.0468 18.0752Z",
    fill: "#0E4C54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8124 0H8.26868C8.08228 0 7.90338 0.0741577 7.77155 0.205994L3.25287 4.72467C3.12103 4.85651 3.04688 5.0354 3.04688 5.2218V21.7906C3.04688 23.0089 4.03802 24 5.25623 24H18.8124C20.0272 24 21.0218 23.0178 21.0218 21.7906V2.20935C21.0218 0.994629 20.0398 0 18.8124 0ZM8.31866 1.6474V4.46869C8.31866 4.91162 7.9585 5.27179 7.51556 5.27179H4.69427L8.31866 1.6474ZM19.6155 21.7906C19.6155 22.2281 19.262 22.5938 18.8124 22.5938H5.25623C4.81348 22.5938 4.45312 22.2334 4.45312 21.7906V6.67822H7.51556C8.73376 6.67822 9.72491 5.68707 9.72491 4.46887V1.40625H18.8124C19.2501 1.40625 19.6155 1.76001 19.6155 2.20935V21.7906Z",
    fill: "#0E4C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.df441b5bbc17cd8c62f7f3b9879b2021.svg";
export { ForwardRef as ReactComponent };